const Table = () => import('@/../../coreui/components/ServerTable')
const SetRelation = () => import('../../components/settings/TaxRelation')

export default function buildMenu (allowed) {
  return [
    // {
    //   path: '/SetFacilities',
    //   name: 'SetFacilities',
    //   component: Table,
    //   props: {
    //     schema: 'sch_set_facilities', 
    //     table: 'set_facilities'
    //   } 
    // },
    {
      path: '/SetRelation',
      name: 'SetRelation',
      component: SetRelation,
    },
    {
      path: '/SetClients',
      name: 'SetClients',
      component: Table,
      props: {
        schema: 'sch_set_clients', 
        table: 'set_clients'
      } 
    },
    {
      path: '/SetContactsPeople',
      name: 'SetContactsPeople',
      component: Table,
      props: {
        schema: 'sch_set_contacts_people', 
        table: 'set_contacts_people'
      } 
    },
    // {
    //   path: '/SetEmployees',
    //   name: 'SetEmployees',
    //   component: Table,
    //   props: {
    //     schema: 'sch_set_employees', 
    //     table: 'set_employees'
    //   }
    // },
    {
      path: '/SetRooms',
      name: 'SetRooms',
      component: Table,
      props: {
        schema: 'sch_set_rooms', 
        table: 'set_rooms'
      } 
    },
    {
      path: '/SetGroups',
      name: 'SetGroups',
      component: Table,
      props: {
        schema: 'sch_set_groups', 
        table: 'set_groups'
      } 
    },
    {
      path: '/SetTransport',
      name: 'SetTransport',
      component: Table,
      props: {
        schema: 'sch_set_transport', 
        table: 'set_transport'
      } 
    },
    {
      path: '/SetStrain',
      name: 'SetStrain',
      component: Table,
      props: {
        schema: 'sch_set_strain', 
        table: 'set_strain'
      } 
    },
    {
      path: '/SetProdtype',
      name: 'SetProdtype',
      component: Table,
      props: {
        schema: 'sch_set_prodtype', 
        table: 'set_prodtype'
      } 
    },
    {
      path: '/SetTax',
      name: 'SetTax',
      component: Table,
      props: {
        schema: 'sch_set_tax', 
        table: 'set_tax'
      } 
    },
    {
      path: '/SetRelation',
      name: 'SetRelation',
      component: Table,
      props: {
        schema: 'sch_set_relation', 
        table: 'set_relation'
      } 
    },
    {
      path: '/SetIntCustomer',
      name: 'SetIntCustomer',
      component: Table,
      props: {
        schema: 'sch_set_int_customer', 
        table: 'set_int_customer'
      } 
    },
    {
      path: '/SetPrinters',
      name: 'SetPrinters',
      component: Table,
      props: {
        schema: 'sch_set_printers', 
        table: 'set_printers'
      } 
    },
    {
      path: '/SetRole',
      name: 'SetRole',
      component: Table,
      props: {
        schema: 'sch_set_role', 
        table: 'set_role'
      } 
    },
    {
      path: '/SetMyLic',
      name: 'SetMyLic',
      component: Table,
      props: {
        schema: 'sch_set_mylic', 
        table: 'set_mylic'
      } 
    }
  ]
}
